import { tabsClasses, useMediaQuery } from "@mui/material";
import React from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import { Box } from "@mui/system";
import TransportStudentMap from "./TransportStudentMap";

const TransportStudent = () => {
  const [value, setValue] = React.useState("1");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <TabsWrapper sx={{ width: isMobile ? "100%" : "auto" }}>
        <TabList
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={isMobile}
          allowScrollButtonsMobile
          sx={{
            [`& .${tabsClasses.scrollButtons}`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
            width: isMobile ? "85vw" : "auto",
          }}
          aria-label="ekalsutra erp tab"
        >
          <Tab label="Trans. Student Map - Transport Card" value="1" />
        </TabList>
      </TabsWrapper>
      <TabPanel value="1" sx={{ p: "0 !important" }}>
        <Box sx={{ my: 1 }}>
          <TransportStudentMap />
        </Box>
      </TabPanel>
    </TabContext>
  );
};

export default TransportStudent;
